"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createMediaQuery = createMediaQuery;
exports.createMediaQueryOrientation = createMediaQueryOrientation;
exports.media = exports.portrait = exports.landscape = exports.minWidth = exports.maxWidth = void 0;

var _isNil2 = _interopRequireDefault(require("lodash/isNil"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _styledComponents = require("styled-components");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Module dependencies.
 */

/**
 * Create media queries based on breakpoint.
 */


var createMediaQueries = function createMediaQueries(query) {
  return function (breakpointKey) {
    return function (styles) {
      for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        interpolations[_key - 1] = arguments[_key];
      }
      /* eslint-disable indent */


      return (0, _styledComponents.css)(["", ""], function (props) {
        var breakpointValue = (0, _get2.default)(props, ['theme', 'breakpoints', breakpointKey]);

        if ((0, _isNil2.default)(breakpointValue)) {
          throw new Error("\uD83D\uDEA8 The '".concat(breakpointKey, "' key was not found on the theme configuration."));
        }

        var renderStyles = _styledComponents.css.apply(void 0, [styles].concat(interpolations));

        if (breakpointValue === 0) {
          return renderStyles;
        }

        return (0, _styledComponents.css)(["", "{", "}"], query(breakpointValue), renderStyles);
      });
      /* eslint-enable indent */
    };
  };
};
/**
 * Export `createMediaQuery`.
 */


function createMediaQuery(boundType) {
  var compensation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return function (breakpoint) {
    return "@media (".concat(boundType, ": ").concat(breakpoint + compensation, "px)");
  };
}
/**
 * Export `createMediaQueryOrientation`.
 */


function createMediaQueryOrientation(boundType) {
  return function (breakpoint) {
    return "@media (max-width: ".concat(breakpoint, "px) and (orientation: ").concat(boundType, ")");
  };
}
/**
 * Export `maxWidth`.
 */


var maxWidth = createMediaQuery('max-width', -1);
/**
 * Export `minWidth`.
 */

exports.maxWidth = maxWidth;
var minWidth = createMediaQuery('min-width');
/**
 * Export `landscape`.
 */

exports.minWidth = minWidth;
var landscape = createMediaQueryOrientation('landscape');
/**
 * Export `portrait`.
 */

exports.landscape = landscape;
var portrait = createMediaQueryOrientation('portrait');
/**
 * Export `media`.
 */

exports.portrait = portrait;
var media = {
  landscape: createMediaQueries(landscape),
  max: createMediaQueries(maxWidth),
  min: createMediaQueries(minWidth),
  portrait: createMediaQueries(portrait)
};
exports.media = media;